import React from "react";

const TitleDetail = ({title,className}) => {
  return (
    <div className={`flex flex-row items-baseline pt-7.5px ${className}`}>
      <p className="whitespace-nowrap pl-2.5 text-grayT text-14">{title}</p>
      <div className="w-full border-t-2 border-grayT"></div>
    </div>
  );
};

export default TitleDetail;
